const locale = {
    VehicleVIOReport: "Fahrzeug-VIO-Bericht",
    ArticleVIOReport: "Artikel VIO-Bericht",
    History: "Geschichte",
    UserManagement: "Benutzerverwaltung"
}

export default locale;